import { render, staticRenderFns } from "./NativeAuthModal.vue?vue&type=template&id=7145fd7c&scoped=true"
import script from "./NativeAuthModal.vue?vue&type=script&lang=js"
export * from "./NativeAuthModal.vue?vue&type=script&lang=js"
import style0 from "./NativeAuthModal.vue?vue&type=style&index=0&id=7145fd7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145fd7c",
  null
  
)

export default component.exports